import CountryBadge from './CountryBadge';

export default CountryBadge;
